import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="loading-container" [class.overlay]="overlay" *ngIf="isLoading">
      <div class="loading-content">
        <div class="spinner" [class]="spinnerClass"></div>
        <p class="loading-text" *ngIf="message">{{ message }}</p>
      </div>
    </div>
  `,
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent {
  @Input() isLoading: boolean = false;
  @Input() message: string = 'Loading...';
  @Input() overlay: boolean = false; // If true, shows as overlay
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() color: 'primary' | 'secondary' | 'white' = 'primary';

  get spinnerClass(): string {
    return `spinner-${this.size} spinner-${this.color}`;
  }
}
